import styled from '@emotion/styled';
import { Radio, Skeleton, Space } from 'antd';
import { useTranslate } from '@tolgee/react';
import { themesColors, Themes } from 'components/ThemesProvider';
import { memo, useMemo } from 'react';

const Wrapper = styled.div`
  display: flex;
`;
const ThemeFrameWrapper = styled.div`
  width: 240px;
  display: flex;
  border: 1px solid rgba(225, 228, 235);
  /* background-color: #000; */
`;
const ThemeNav = styled.div`
  width: 40px;
  flex-basis: 40px;
  padding: 10px 0 20px 0;
  background-color: currentColor;
  text-align: center;
  > div {
    margin: 10px 0;
  }
`;
const ThemeMain = styled.div`
  width: 80px;
  padding: 20px 0 20px 18px;
  flex: 2;
  > div {
    margin: 10px;
  }
  ${({ theme: { getAntdPrefixedClassName } }) => {
    return `.${getAntdPrefixedClassName('skeleton-paragraph')}{
       margin-bottom:0;
   }`;
  }}
`;
const ThemeRadioItem = styled.div`
  display: inline-block;
  margin-right: 30px;

  ${({ theme: { getAntdPrefixedClassName } }) => {
    return `.${getAntdPrefixedClassName('radio-wrapper')}{
      border: 1px solid rgba(225, 228, 235);
      border-top: 0;
      width: 100%;
      height: 40px;
      padding: 0 10px;
      line-height: 40px;
      &-checked{
          background: #E9F3FF;
      }
   }`;
  }}
`;

export interface ThemeSelectorProps {
  onChange: (theme: Themes) => void;
  value: Themes;
}

const ThemeFrame = ({ color }: { color: string }) => {
  return (
    <ThemeFrameWrapper style={{ color }}>
      {useMemo(
        () => (
          <>
            <ThemeNav>
              <div>
                <Skeleton.Avatar size={22} />
              </div>
              {new Array(3).fill(
                <div>
                  <Space>
                    <Skeleton.Avatar size={24} shape="square" />
                  </Space>
                </div>,
              )}
            </ThemeNav>
            <ThemeMain>
              {new Array(3).fill(
                <div>
                  <Space>
                    <Skeleton.Avatar size={26} />
                    <Skeleton title={false} paragraph={{ rows: 1, width: 120 }} />
                  </Space>
                </div>,
              )}
            </ThemeMain>
          </>
        ),
        [],
      )}
    </ThemeFrameWrapper>
  );
};

const ThemeSelector = (props: ThemeSelectorProps) => {
  const { onChange, value } = props;
  const { t } = useTranslate();

  return (
    <Wrapper>
      <Radio.Group name="theme" value={value}>
        <ThemeRadioItem onClick={() => onChange('Blue')}>
          <ThemeFrame color={themesColors.Blue.primaryColor} />
          <Radio value="Blue">{t('aide.极致蓝')}</Radio>
        </ThemeRadioItem>
        <ThemeRadioItem onClick={() => onChange('Orange')}>
          <ThemeFrame color={themesColors.Orange.primaryColor} />
          <Radio value="Orange">{t('aide.活力橘')}</Radio>
        </ThemeRadioItem>
      </Radio.Group>
    </Wrapper>
  );
};
export default memo(ThemeSelector);
